<template>
  <div>
    <Draft v-if="draft" />
    <Published v-if="published" :status="story.status.id" :statusUpdatedAt="statusUpdatedAt" />
  </div>
</template>
<script>
import gql from 'graphql-tag'
import iris from "@/iris";
import Draft from "./Draft"
import Published from "./Published"
import { STORY_STATUS } from "@/const"
export default {
  components: {
    Draft,
    Published,
  },
  apollo: {
    story: {
      query: gql`query GetStory($id: ID!){
        story(id: $id) {
          id
          owner {
            email
          }
          status {
            id
          }
          statusUpdatedAt
        }
      }
      `,
      variables() {
        return {
          id: this.id
        }
      }
    }
  },
  computed: {
    id() {
      return `${iris.story}${this.$route.params.id}`;
    },
    published() {
      return (this.story?.status?.id == iris.status + STORY_STATUS.Published || this.story?.status?.id == iris.status + encodeURI(STORY_STATUS.InReview) ) 
    },
    draft() {
      return (this.story?.status?.id == iris.status + STORY_STATUS.Draft) 
    },
    statusUpdatedAt() {
      return this.story?.statusUpdatedAt
    }
  }
};
</script>